import React from "react";
import { SCENARIO, SHOTS } from "../mock";
import DeviceFrame from "./renn/DeviceFrame";
import Reveal from "./Reveal";

const ScenarioPlanner = () => {
  return (
    <section className="relative py-20 lg:py-28 bg-[#0A1220]">
      <div className="max-w-6xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <p className="text-[13px] font-semibold tracking-wide text-[#13D99A] uppercase mb-4">Scenario planner</p>
          <h2 className="font-display text-3xl lg:text-5xl font-bold text-[#F5F7FB] leading-[1.08]">
            {SCENARIO.headline}
          </h2>
          <p className="mt-5 text-lg text-[#8290A8] leading-relaxed">{SCENARIO.copy}</p>
          <div className="mt-8 flex flex-wrap gap-2.5">
            {SCENARIO.examples.map((e) => (
              <span key={e} className="text-sm text-[#F5F7FB] rounded-full border border-[#29354A] bg-[#121A28] px-4 py-2">
                {e}
              </span>
            ))}
          </div>
          <p className="mt-6 text-sm text-[#8290A8]">{SCENARIO.note}</p>
        </Reveal>

        <Reveal delay={100} className="flex justify-center lg:justify-end">
          <DeviceFrame src={SHOTS.scenario} alt="Renn scenario planner screen" className="w-full max-w-[360px]" />
        </Reveal>
      </div>
    </section>
  );
};

export default ScenarioPlanner;
